const API_KEY = "AIzaSyA354_16dD8ThP5kgyaeW0v5Mf0Db3-7Tg";
const GMAPS_API = "AIzaSyAp-KcWXcOGQV1DTEB1vzyIDxO3DPMsQwI";

export { API_KEY, GMAPS_API };


// WEBPACK FOOTER //
// ./src/firebase/config.js